import { render, staticRenderFns } from "./PaymentCollectionTable.vue?vue&type=template&id=fd52f172"
import script from "./PaymentCollectionTable.vue?vue&type=script&lang=ts"
export * from "./PaymentCollectionTable.vue?vue&type=script&lang=ts"
import style0 from "./PaymentCollectionTable.vue?vue&type=style&index=0&id=fd52f172&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports